import { Cell } from '@table-library/react-table-library/table';

/**
 * The table this report defines for itself: what the review covered. The candidate and page
 * tables are the shared GSC tool column set with this report's own reason column appended.
 */

export const COVERAGE_COLUMNS = (t) => [
    {
        label: t('tools.search_opportunities.coverage.item'),
        key: 'item',
        data: 'item',
        sortType: 'string',
        cellSize: 'minmax(260px, 2fr)',
        Component: Cell,
    },
    {
        label: t('tools.search_opportunities.coverage.value'),
        key: 'value',
        data: 'value',
        sortType: 'string',
        cellSize: 'minmax(220px, 1.6fr)',
        Component: Cell,
        renderCell: ({ data }) => data ?? '—',
    },
];

/** The column that says why a row is in the queue, appended to the shared candidate columns. */
export const reasonColumn = (t) => ({
    label: t('tools.search_opportunities.candidates.reason'),
    key: 'reason',
    data: 'reason',
    sortType: 'string',
    cellSize: 'minmax(220px, 1.8fr)',
    Component: Cell,
    renderCell: ({ data, csvDownload }) =>
        csvDownload ? data : <span className="gsc-tool-sub">{data}</span>,
});
